var map = {
	"app/auth/auth.module": [
		"../../../../../src/app/auth/auth.module.ts",
		"auth.module",
		"common"
	],
	"app/pages/contratos/contratos.module": [
		"../../../../../src/app/pages/contratos/contratos.module.ts",
		"contratos.module"
	],
	"app/pages/dashboard/dashboard.module": [
		"../../../../../src/app/pages/dashboard/dashboard.module.ts",
		"common"
	],
	"app/pages/faturas/faturas.module": [
		"../../../../../src/app/pages/faturas/faturas.module.ts",
		"common",
		"faturas.module"
	],
	"app/pages/fiberhome/fiberhome.module": [
		"../../../../../src/app/pages/fiberhome/fiberhome.module.ts",
		"common",
		"fiberhome.module"
	],
	"app/pages/pages.module": [
		"../../../../../src/app/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"app/pages/parcelamento/parcelamento.module": [
		"../../../../../src/app/pages/parcelamento/parcelamento.module.ts",
		"common",
		"parcelamento.module"
	],
	"app/pages/suporte/suporte.module": [
		"../../../../../src/app/pages/suporte/suporte.module.ts",
		"suporte.module",
		"common"
	],
	"app/segunda-via/segunda-via.module": [
		"../../../../../src/app/segunda-via/segunda-via.module.ts",
		"segunda-via.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main